import { motion } from "framer-motion";
import { PageShell } from "../components/layout/PageShell";
import { LeadForm } from "../components/shared/LeadCapture";
import { CONNECT } from "../data/siteContent";

export default function ConnectPage() {
  return (
    <PageShell>
      <section data-testid="connect-page" className="relative pt-36 md:pt-44 pb-16 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="line-weave" />
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
          <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">{CONNECT.eyebrow}</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-5">
            Begin a <span className="text-gold">conversation.</span>
          </h1>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto">{CONNECT.sub}</p>
        </div>
      </section>

      <section className="relative py-10 md:py-20 bg-[#0B1020] overflow-hidden">
        <div className="max-w-xl mx-auto px-5 md:px-8">
          <motion.div data-testid="connect-form" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="glass rounded-3xl p-8 md:p-10">
            <h2 className="font-display text-2xl md:text-3xl text-cream mb-2">{CONNECT.form.title}</h2>
            <p className="text-cream/60 mb-7">{CONNECT.form.note}</p>
            <LeadForm withMessage={CONNECT.form.withMessage} topics={CONNECT.form.topics} />
          </motion.div>
        </div>
      </section>
    </PageShell>
  );
}
